<template>
  <q-layout view="lHh Lpr lFf">
    <router-view />
  </q-layout>
</template>
<script>

export default {


  data() {
    return {

    }
  }
}
</script>

<style>
body,
html,
#q-app {
  overflow-x: hidden;
  height: 100%;
  margin: 0;
}

.q-table thead {
  border-color: #0094ca !important;
}
</style>
